import { css } from "@emotion/react";
import { styled } from "../../theme";
import { DatePicker } from "../../date-picker";
import { Text } from "../../text";
import { Tooltip } from "../../tooltip";
import { DropdownSelectList, DropdownSelectOption } from "../../dropdown-select";
export const CheckboxWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 0.625em;

  &:last-of-type {
    margin-bottom: 0;
  }
`;
export const ClickOutsideWrapper = styled.div ``;
export const Label = styled.label `
  display: flex;
  cursor: pointer;
  width: 100%;
  align-items: center;
  padding: 4px 6px;

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }

  ${({ disabled, theme }) => disabled
    ? css `
          cursor: not-allowed;
        `
    : css `
          &:hover {
            background: ${theme.color.lightBlue10};
          }
        `};

  ${({ isOpened, theme }) => isOpened &&
    css `
      background: ${theme.color.lightBlue10};
    `};
`;
export const LabelText = styled(Text) `
  font-size: 1.25em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  ${({ strikeThrough, theme }) => strikeThrough &&
    css `
      text-decoration: line-through;
      color: ${theme.color.darkBlue70};
    `};
`;
export const StyledDatePicker = styled(DatePicker) `
  z-index: 1000;
`;
export const FormattedDate = styled.time `
  white-space: nowrap;
  margin-left: auto;

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
    `};
`;
export const StyledTooltip = styled(Tooltip) `
  overflow: hidden;
  display: flex;
  align-items: center;

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
    `};
`;
export const StyledDropdownSelectList = styled(DropdownSelectList) `
  margin-top: 0;
`;
export const StyledDropdownSelectOption = styled(DropdownSelectOption) `
  position: relative;
  padding: 8px 12px 8px 40px;

  .icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 38px;
    line-height: 33px;
    display: inline-block;
    text-align: center;
  }
`;
